import * as z from "zod";

const objectIdHex = z.string().regex(/^[0-9a-f]{24}$/i);

/**
 * Opts FAQ articles into the agent's knowledge base. Already-linked and
 * unresolvable articles are skipped rather than failing the batch.
 */
export const linkFaqKnowledge = {
  name: "linkFaqKnowledge" as const,
  input: z.object({
    links: z.array(
      z.object({
        faqPageId: objectIdHex,
        faqCollectionId: objectIdHex,
        faqArticleId: objectIdHex,
      }),
    ),
  }),
  output: z.object({ linkedCount: z.number() }),
};
